import React from 'react';

import { Modal as AntdModal } from 'antd';

import { CentreVHUDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

import './ModalDetails.less';

interface ModalDetailsProps {
  centreVHU: CentreVHUDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  centreVHU,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <AntdModal
      visible={visible}
      onCancel={close}
      footer={null}
      destroyOnClose={true}
      width={BaseModalWidthUtils.xLargeWidth}
      maskClosable={false}
      className="modalDetails"
    >
      <FieldDisplay
        label={LABEL_ID_CORRELATION}
        value={centreVHU.idCorrelation}
      />
      <FieldDisplay label="Raison sociale" value={centreVHU.raisonSociale} />
      <FieldDisplay label="SIREN" value={centreVHU.siren} />
      <FieldDisplay label="Adresse" value={centreVHU.adresse} />
      <FieldDisplay
        label="Complément d'adresse"
        value={centreVHU.complementAdresse}
      />
      <FieldDisplay label="Code postal" value={centreVHU.codePostal} />
      <FieldDisplay label="Commune" value={centreVHU.commune} />
      <FieldDisplay label="Téléphone" value={centreVHU.telephone} />
      <FieldDisplay label="Adresse mail" value={centreVHU.adresseMail} />
      <FieldDisplay
        label="Numéro agrément"
        value={centreVHU.numeroAgrementVHU}
      />
      <FieldDisplay
        label="Préfecture ayant délivré le numéro d'agrément"
        value={centreVHU.prefecture}
      />
    </AntdModal>
  );
}

export default ModalDetails;
